import * as React from "react";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import { ScreenMode } from "../../../models/enums";
import { ILocalization } from "../../../models/localization";
import LegalStore from "../../../stores/legalStore";
import SeekerStore from "../../../stores/SeekerStore";
import Button from "material-ui/Button";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from "material-ui/Dialog";

@observer
export default class DisclaimerDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const ls: LegalStore = this.props.store.legal;
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;

    return <Dialog
      open={this.props.store.legal.showDisclaimer}
      aria-labelledby="responsive-dialog-title"
      fullScreen={mode === ScreenMode.Mobile} >
      <DialogTitle>{local.disclaimerDlg.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div dangerouslySetInnerHTML={{ __html: ls.disclaimerText }}></div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => ls.hideDisclaimer()} >{this.props.store.localization.fields.close}</Button>
      </DialogActions>
    </Dialog >
  }
} 


// WEBPACK FOOTER //
// ./src/components/dialogs/disclaimer/index.tsx